import {styled} from '@esgi/ui/theme';
import {Alert} from '@esgi/ui/alert';

export const AlertBody = styled(Alert.Body, {
	maxHeight: '750px',
	maxWidth: '508px',
});
